// Hash display component with copy buttons
// Frontend developers can modify the visual appearance here

import type { HashResult } from "../types";

interface HashDisplayProps {
  hashes: HashResult;
}

export function HashDisplay({ hashes }: HashDisplayProps) {
  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="results">
      <div className="hash-result">
        <div className="hash-header">
          <h3>96-bit Hash</h3>
          <button
            className="copy-btn"
            onClick={() => copyToClipboard(hashes.dinohash96.hex)}
          >
            Copy
          </button>
        </div>
        <code className="hash-value">{hashes.dinohash96.hex}</code>
      </div>

      <div className="hash-result">
        <div className="hash-header">
          <h3>512-bit Hash</h3>
          <button
            className="copy-btn"
            onClick={() => copyToClipboard(hashes.dinohash512.hex)}
          >
            Copy
          </button>
        </div>
        <code className="hash-value">{hashes.dinohash512.hex}</code>
      </div>
    </div>
  );
}
